import React from 'react';
import PropTypes from 'prop-types';

import StoryletRoot from 'components/StoryletRoot';

import NameableQuality from './components/NameableQuality';
// import RenameFormContainer from './components/RenameFormContainer';

export default function RenameComponent(props) {
  const {
    branch,
    onGoBack,
    qualities,
  } = props;

  return (
    <div>
      <StoryletRoot data={branch} />
      {qualities.map(q => (
        <NameableQuality
          branchId={branch.id}
          key={q.qualityPossessedId}
          qualityName={q.name}
          qualityPossessedId={q.qualityPossessedId}
        />
      ))}
      <p className="buttons buttons--left">
        <button className="button button--primary" onClick={onGoBack} type="button">
          <i className="fa fa-arrow-left" />
          {' '}
          Back
        </button>
      </p>
    </div>
  );
}

RenameComponent.propTypes = {
  branch: PropTypes.shape({}).isRequired,
  onGoBack: PropTypes.func.isRequired,
  qualities: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};